import { useAppDispatch } from 'config/hooks';
import { useCallback } from 'react';
import { doHideGlobalOverlay, doShowGlobalOverlay, DoShowGlobalOverlayParams } from 'store/global-overlay/action';

const useGlobalOverlay = () => {
    const dispatch = useAppDispatch();

    const showGlobalOverlay = useCallback(
        async (params: DoShowGlobalOverlayParams) => {
            return await dispatch(doShowGlobalOverlay(params));
        },
        [dispatch]
    );

    const hideGlobalOverlay = useCallback(async () => {
        return await dispatch(doHideGlobalOverlay());
    }, [dispatch]);

    return { showGlobalOverlay, hideGlobalOverlay };
};

export default useGlobalOverlay;
